<template>
  <v-card class="elevation-12">
    <v-toolbar color="primary" dark flat>
      <v-toolbar-title>
        水防災オープンデータ配信システム 運用管理画面
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-form v-model="valid" @submit.prevent>
        <v-text-field
          v-model="loginId"
          :rules="loginRules"
          label="ログインID"
          required
          class="ml-3 mr-3"
          prepend-icon="person"
          maxlength="100"
        />
        <v-text-field
          v-model="password"
          type="password"
          label="パスワード"
          required
          class="ml-3 mr-3"
          prepend-icon="lock"
          @keypress.enter="login"
          maxlength="100"
        />
      </v-form>
      <v-snackbar v-model="snackbar" top color="error">
        {{ loginErrorMessage }}
      </v-snackbar>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn @click="login" color="primary" :disabled="!valid">
        ログイン
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script lang="ts">
import loginModule from "../../store/LoginModule";
import { Component, Vue } from "vue-property-decorator";
import { message } from "../../config/config";
import { NETWORK_ERROR } from "../../router";

@Component
export default class Login extends Vue {
  valid = false;

  loginId = "";
  password = "";

  snackbar = false;
  loginErrorMessage = "";

  get loginRules() {
    return [
      (v: string) =>
        !!v || message.getMessageAndReplace("MSG001", "ログインID"),
    ];
  }

  async login() {
    if (!this.valid) {
      return;
    }

    let result: boolean;
    try {
      result = await loginModule.login({
        loginId: this.loginId,
        password: this.password,
      });
    } catch (error) {
      if (error instanceof Error) {
        if (error.message === "401") {
          // 認証失敗
          this.loginErrorMessage = message.getMessage("MSG002");
          this.snackbar = true;
        } else {
          // 運用上起こってはいけないエラー
          await this.$router.push({ name: error.message });
        }
      } else {
        // 運用上起こってはいけないエラー
        this.$router.push({ name: NETWORK_ERROR });
      }
      return;
    }
    if (result) {
      await this.$router.push({ name: "Menu" });
    }
  }
}
</script>
<style lang="scss" scoped></style>
